import { createTheme, PaletteColorOptions, PaletteOptions } from '@mui/material_v7/styles';

import colors, { wlSecondary } from './colors';
import getOverriddenStyles from './overriddenStyles';
import shadowsTheme from './shadows';
import typographyTheme from './typography';

export type WLColor = {
  dark: string;
  main: string;
  light1: string;
  light2: string;
  light3: string;
};

// color adapter for old mui version theme to make WL working
const adapter = (color: WLColor): PaletteColorOptions => ({
  600: color.dark,
  500: color.main,
  400: color.light3,
  300: color.light2,
  200: color.light1,
});

const getPalette = (wlPrimary?: WLColor): PaletteOptions => {
  // return design-system theme
  if (!wlPrimary) return colors;

  // override primary & secondary colors with WL colors
  return {
    ...colors,
    primary: {
      ...colors.primary,
      ...adapter(wlPrimary),
    },
    secondary: {
      ...colors.secondary,
      ...wlSecondary,
    },
  };
};

const getTheme = (wlPrimary?: WLColor) => {
  const theme = createTheme({ palette: getPalette(wlPrimary) });

  return createTheme({
    palette: theme.palette,
    shadows: shadowsTheme.shadows,
    typography: typographyTheme.typography,
    components: getOverriddenStyles({ ...theme, typography: typographyTheme.typography }),
  });
};

export default getTheme;
